import $ from "jquery";

const detectLang = function () {
	const $body = $("body");

	if ($body.hasClass("style-lang-en")) {
		return "en";
	} else if ($body.hasClass("style-lang-jp")) {
		return "jp";
	} else if ($body.hasClass("style-lang-cn")) {
		return "cn";
	} else {
		return "tw";
	}
};

export default detectLang;
